<template>
  <div class="container">
    <div class="title">我的干货</div>
    <div class="content">
      <div class="content_box" v-for="(item,index) in buyList" :key="index" @click="indexDetail(item.id)">
        <div class="content_box_tit">{{item.title}}</div>
        <div class="content_box_text">
          <div class="content_box_text_left">
            <div class="left_say">
                <img class="left_say_icon" :src='userImg' alt="">
                <div class="font3">小姨妈说</div>
            </div>
            <div class="left_text">{{item.desc}}</div>
            <div class="font_style">{{item.order_num}}人已学</div>
          </div>
          <div class="content_box_text_right">
            <img class="right_icon" :src='item.img_url' alt="">
          </div>
          
        </div>
        
      </div>
      
  
  </div>
  <div class="title">未购买干货</div>
    <div class="content">
      <div class="content_box" v-for="(item,index) in nobuyList" :key="index" @click="indexDetail(item.id)">
        <div class="content_box_tit">{{item.title}}</div>
        <div class="content_box_text">
          <div class="content_box_text_left">
            <div class="left_say">
                <img class="left_say_icon" :src='userImg' alt="">
                <div class="font3">小姨妈说</div>
            </div>
            <div class="left_text">{{item.desc}}</div>
            <div class="font_style">{{item.order_num}}人已学</div>
          </div>
          <div class="content_box_text_right">
            <img class="right_icon" :src='item.img_url' alt="">
          </div>         
        </div>       
      </div>
  
  </div>
  </div>
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$rem = 100;
.container{
  overflow-y: scroll;
  // font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  color: rgb(34,34,34);
}
.title{
  height :45px;
  line-height :45px;
  font-size :16px;
  font-weight :bold;
  color:rgb(34,34,34);
  padding-left 15px;
  box-sizing :border-box;
  background-color :#fff;
  border-bottom:1px solid #e7e7e7;
}
.content{
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 50px;
}
.tit{
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}
.tit1{
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  color:#B3212D;
}
.sort1{
  /* height: 20px;
  line-height: 20px; */
  font-size: 12px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 8px;
}
.content_box{
  width: 100%;
  /* height: 140px; */
  background-color: #fff;
  box-sizing: border-box;
  // margin-top: 5px;
  border-bottom: 1px solid #e7e7e7;
  padding-top: 8px;
  padding-bottom: 5px;
}
.content_box_tit{
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.content_box_text{
  display: flex;
  flex-direction: row;
}
.left_say{
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  align-items: center;
  margin-bottom: 10px;
}
.left_say_icon{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.font3{
  font-size: 14px;
  /* color:#696969; */
  color: rgb(34,34,34);
}
.font_style{
  font-size: 12px;
  color: rgb(123,123,123);
  margin-bottom: 10px;
}
.left_text{
    /* color:#696969; */
    color: rgb(34,34,34);
    letter-spacing: 1px;
    font-size: 14px;
    -o-text-overflow: -o-ellipsis-lastline;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    line-height: 20px;
}
.content_box_text_left{
  flex: 5;
}
.content_box_text_right{
  flex: 3;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.right_icon{
  width: 100px;
  height: 60px;
}

</style>

<script>
import { ghList } from '../apollo/apollo'
export default {
   components: {
    
  },
  data() {
    return {
      userImg:'./static/imgs/user.jpg',
      explainImg:'./static/imgs/3.jpg',
      ghList:ghList,
      getMyArticle:[],
      buyList:[],
      nobuyList:[],
 
    }
  },
  computed:{
    
  },
  created() {
    this.getinit()
  },
  mounted(){
 
  },
  methods: {
    indexDetail(i){
      // this.$store.state.id=i
      sessionStorage.setItem('article_id',i);
      this.jump('./indexDetail')
    },
    getinit(){
      document.title=this.$store.state.title;
      ghList().then(res=>{
        res.data.getMyArticle.map((ele,idx)=>{
          if(ele.status==1){
            this.buyList.push(ele)
          }else if(ele.status==0){
            this.nobuyList.push(ele)
          }
        })

        })
        .catch(err=>{
          this.msgManage(err)
        })
    }

  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/ghList.vue